import { SubmitAppointmentErrorCode } from '@src/constants';
import makeRequestHeaders from '@src/utils/make-request-headers';

const submitAppointment = async ({
	consultId,
	leadId,
	sessionId = 'N/A',
}: {
	consultId: string;
	leadId: string;
	sessionId: string | undefined;
}) => {
	try {
		const response = await fetch(process.env.APP_PATH + '/api/clear-choice/submit-appointment/', {
			headers: makeRequestHeaders({
				sessionId,
			}),
			method: 'PATCH',
			body: JSON.stringify({
				consultId,
				leadId,
			}),
		});

		const data = await response.json();

		if (!response.ok) {
			if (data?.status === SubmitAppointmentErrorCode.CONSULT_SCHEDULED) {
				throw new Error(SubmitAppointmentErrorCode.CONSULT_SCHEDULED);
			} else if (data?.status === SubmitAppointmentErrorCode.NO_APPOINTMENTS) {
				throw new Error(SubmitAppointmentErrorCode.NO_APPOINTMENTS);
			}
			throw new Error(response.statusText);
		}
		return data;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(`Failed Submitting Appointment`);
		}
		return [];
	}
};

export { submitAppointment };
